import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-sn.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-sn.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationDetailsSnConstants } from "./create-application-details-sn.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationDetailsSnComponent = class CreateApplicationDetailsSnComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appControllerService;
    changeDetectorRefs;
    detailsForm;
    applicationDetailsFormGroupName = CreateApplicationDetailsSnConstants.APPLICATION_DETAILS_FORM_GROUP_NAME;
    descriptionFormControlName = CreateApplicationDetailsSnConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsSnConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsSnConstants.DESCRIPTION_FORM_LABEL;
    applicationTypeLabel = CreateApplicationDetailsSnConstants.APPLICATION_TYPE_FORM_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypes = [];
    validationMessages = CreateApplicationDetailsSnConstants.VALIDATION_MESSAGES;
    applicationTypeLookoutName = CreateApplicationDetailsSnConstants.APPLICATION_TYPE_LOOKOUT_NAME;
    getLookupsObservableSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, appControllerService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        if (this.appControllerService.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.applicationType;
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has(this.applicationTypeLookoutName)) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get(this.applicationTypeLookoutName);
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
    }
    loadMetadata(stepMeta) {
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.createApplicationService.getLookupsObservable(params).subscribe({
            next: (response) => {
                const lookups = response.value;
                if (lookups.length > 0) {
                    this.getLookupCompleted(lookups);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsSnConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.applicationDetailsFormGroupName);
    }
    getLookupCompleted(lookups) {
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "applicationtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.applicationTypes.push(lookUpContent);
            }
        });
        this.applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set(this.applicationTypeLookoutName, this.applicationTypes);
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsSnComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details-sn",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsSnComponent);
export { CreateApplicationDetailsSnComponent };
